"use client";

import { useRouter } from "next/navigation";

/** The legacy LoadFailureState's retry: re-run this segment's server render,
 *  keeping scroll and client state (unlike a full reload). */
export default function DocRetry({ label }: { label: string }) {
  const router = useRouter();
  return (
    <button type="button" className="v2-btn v2-btn--ghost v2-btn--sm v2-focus" onClick={() => router.refresh()}>
      {label}
    </button>
  );
}
